import React from 'react';
import {
  LabelledIcon,
  LabelledIconBody,
  LabelledIconLeftColumn,
  LabelledIconRow,
} from '#components/Elements/LabelledIcon/LabelledIcon';
import EntityIcon from './EntityIcon.js';

/**
 * Component that renders an avatar with two lines of text
 */
const LabelledEntityIcon = ({
  contactIsLoaded,
  src,
  initials,
  displayName,
  displayHandle,
  headline = displayName,
  subtitle,
  className,
  descriptionClassName,
  iconClassName,
  inverted,
  lozenge,
  rightColumn,
  test,
  showAddress,
  address,
}) => (
  <LabelledIconRow
    className={className}
    inverted={inverted}
    contactIsLoaded={contactIsLoaded}
    displayName={displayName}
    displayHandle={displayHandle}
    test={test}
  >
    <LabelledIcon className={iconClassName}>
      <EntityIcon
        src={src}
        initials={initials}
        displayName={displayName}
        size="medium"
        inverted={inverted}
      />
    </LabelledIcon>
    <LabelledIconBody>
      <LabelledIconLeftColumn className={descriptionClassName}>
        {lozenge ? (
          <h2>
            <span>{headline}</span>
            {lozenge}
          </h2>
        ) : (
          <h2>{headline}</h2>
        )}
        <p>{subtitle}</p>
      </LabelledIconLeftColumn>
      {rightColumn || null}
    </LabelledIconBody>
  </LabelledIconRow>
);

export default LabelledEntityIcon;
